<style lang="scss">
  @import './index.scss';
</style>
<template>
    <div class="err-list">
        <div class="err-list-header">
            <h1>{{$t('errlist.title')}}</h1>
            <div class="err-list-searchbox">
                <i-input icon="ios-search" v-model="key" :placeholder="$t('errlist.searchplace')"  class="err-lsit-search" @keyup.native="getSearchData"></i-input>
                <i class="iconfont icon-download err-list-icon" @click="downTable"></i>
            </div>
        </div>
        <div class="err-list-content">
            <i-table ref='table' :columns="tableColumns" :data="tableData" :no-data-text="noData" @on-sort-change="sortData" class="errlist-table">
            </i-table>
        </div>
        <div class="err-list-footer">
            <div class="pageOpts">
                <i-select v-model="pageSize" style="width:80px;" @on-change="changePage(1)">
                    <i-option v-for="item in pageSizeOpts" :value="item" :key='item'>{{item}}{{ $t('accountAuthorization.pagesize') }}</i-option>
                </i-select>
            </div>
            <div class="page">
                <Page :total="pages" :current="curPage" :page-size="pageSize" :page-size-opts="pageSizeOpts" @on-change="changePage"></Page>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import bus from '../../libs/bus';
import busModual from '../../libs/busModual';
import util from '../../libs/util';
import numberSeparator from '../../filters/number-separator';

export default {
  props: {},
  components: {},
  data() {
    return {
      key: '',
      tableColumns: [],
      tabDatas: [],
      tableData: [], // 绑定到table的data
      noData: this.$t('common.loading'),
      allExpList: [], // 所有的exception_type1列表
      exceList: [], // 传参时condition里的exceptionType1_list,这里是全量的
      // 分页
      pages: 0,
      curPage: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      relationCodeList: [], // 错误报表页使用的原始version code
      // 用于取消请求
      source: axios.CancelToken.source(),
    };
  },
  computed: {},
  watch: {
    tableData() {
      this.getAbstract();
    },
  },
  mounted() {
    bus.$on('on-app-change', () => {
      this.init();
    });
    bus.$on('on-platform-change', () => {
      this.init();
    });
    bus.$on('on-conditions-change', () => {
      this.init();
    });
    bus.$on('on-date-change', () => {
      this.init();
    });
    bus.$on('on-change-lang', this.changeColumns);
    this.init();
  },
  beforeDestroy() {
    // 清除请求
    this.source.cancel('clear request');
    bus.$off('on-app-change');
    bus.$off('on-platform-change');
    bus.$off('on-conditions-change');
    bus.$off('on-date-change');
    bus.$off('on-change-lang', this.changeColumns);
  },
  methods: {
    init() {
      // 清除请求
      this.source.cancel('clear request');
      this.source = axios.CancelToken.source();
      this.noData = this.$t('common.loading');
      this.tabDatas = [];
      this.tableData = [];
      this.pages = 0;
      this.curPage = 1;
      this.tableColumns = this.getColumns();
      if (!bus.productInfo.productid) return;
      this.getRelationCodeList();
    },
    //切换表头的中文
    changeColumns() {
      this.tableColumns = this.getColumns();
    },
    // 获取原始version code值
    getRelationCodeList() {
      if (bus.conditions.version.length) {
        // 若bus中已记录，直接赋值
        // bus中没有记录，根据bus.conditions.version中的值取获取关联code
        if (busModual.errPageVersion.length) {
          this.relationCodeList = busModual.errPageVersion;
          this.getErrTypeTime();
        } else {
          this.getRelationCode().then((res) => {
            // 去重复数据
            const relationVersion = this.removalVersion(res);
            this.relationCodeList = relationVersion.map(item => item.versioncode);
            this.getErrTypeTime();
          });
        }
      } else {
        this.relationCodeList = [];
        this.getErrTypeTime();
      }
    },
    // 获取错误报告页面与其他页面相互关联的versionCode
    getRelationCode() {
      const params = {
        productid: bus.productid,
        platformid: bus.platform.toString(),
        versioncodelist: bus.conditions.version.toString(),
      };
      return util.ajax.get('/app/rest/version.json/getRelatedVersion', { params });
    },
    // 版本去重复
    removalVersion(data) {
      const tempObj = {};
      const result = [];
      data.forEach((item) => {
        const versioncode = item.versioncode;
        if (!tempObj[versioncode]) tempObj[versioncode] = item;
      });
      Object.keys(tempObj).forEach((item) => {
        result.push(tempObj[item]);
      });

      return result;
    },
    // 获取表头
    getColumns() {
      const self = this;
      const list = [{
        key: 'type',
        title: `${this.$t('errlist.table.columnt')} | ${this.$t('errlist.table.columne')}`,
        render: (h, params) => (h('a', {
          on: {
            click: () => {
              self.checkDetail(params.row.exception_type1);
            },
          },
        }, `${params.row.type}`)),
//        render(row) {
//          return `<a @click="checkDetail('${row.exception_type1}')">${row.type}</a>`;
//        },
      }, {
        key: 'last',
        align: 'right',
        title: this.$t('errlist.table.column2'),
        sortable: true,
      }, {
        key: 'today',
        align: 'right',
        title: this.$t('errlist.table.column3'),
        sortable: 'custom',
        render: (h, params) => (h('div', `${numberSeparator(params.row.today)}`)),
//        render(row) {
//          return `${numberSeparator(row.today)}`;
//        },
      }, {
        key: 'week',
        align: 'right',
        title: this.$t('errlist.table.column4'),
        sortable: 'custom',
        render: (h, params) => (h('div', `${numberSeparator(params.row.week)}`)),
//        {
//          return `${numberSeparator(row.week)}`;
//        },
      }, {
        key: 'interval',
        align: 'right',
        title: this.$t('errlist.table.column5'),
        sortable: 'custom',
        render: (h, params) => (h('div', `${numberSeparator(params.row.interval)}`)),
//        render(row) {
//          return `${numberSeparator(row.interval)}`;
//        },
      }];
      return list;
    },
    // 自定义排序
    sortData(obj) {
      const data = this.tabDatas;
      const list = this.pageSort(obj, data);
      this.getTableData(list, 1);
      // this.getAbstract();
    },
    pageSort(obj, saveData) {
      const key = obj.key;
      const order = obj.order;
      const data = saveData;
      if (order === 'normal') {
        return data;
      }
      if (order === 'asc') {
        data.sort((a, b) => a[key] - b[key]);
      } else if (order === 'desc') {
        data.sort((a, b) => b[key] - a[key]);
      }
      return data;
    },
    getErrTypeTime() {
      const param = {
        metrics: ['exception'],
        groupby: 'exception_type1',
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: bus.isAllPlatform ? '' : bus.platform.toString(),
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          usergroup_list: bus.conditions.usergroup.length === 0 ? undefined
          : bus.conditions.usergroup,
          version_list: this.relationCodeList.length ? this.relationCodeList : undefined,
        },
        pageid: `exceptionList_${bus.token}`,
      };
      util.ajax.post('/app/rest/data.json/query', param, {
        cancelToken: this.source.token,
      }).then((res) => {
        // 限制条数为1000条
        this.allExpList = res;
        const data = res;
        if (data.length > 1000) {
          data.length = 1000;
        }
        // 传入type1_list  datail接收
        bus.errTypeList = data;
        const len = data.length;
        if (len > 0) {
          for (let i = 0; i < len; i++) {
            const p = {};
            p.exception_type1 = data[i].exception_type1;
            p.type = '--';
            p.last = new Date(data[i].exception).format('yyyy-MM-dd hh:mm:ss');
            p.today = '--';
            p.week = '--';
            p.interval = '--';
            this.tabDatas.push(p);
          }
          this.getData(data);
        } else {
          this.noData = this.$t('common.nodata');
        }
        this.getSearchData();
      }).catch((thrown) => {
        if (axios.isCancel(thrown)) {
          // 请求取消
        }
      });
    },
    // 错误类型|错误摘要
    getAbstract() {
      const self = this;
      const data = self.tableData;
      const list = [];
      // 过滤错误类型为'--'的错误，去获取其错误类型的描述
      Object.keys(data).forEach((i) => {
        if (data[i].type === '--') {
          const item = `exceptionType1_list=${data[i].exception_type1}`;
          list.push(item);
        }
      });
      if (list.length < 1) return;
      let params = [
        list.join('&'),
        `platformid=${bus.platform.toString()}`,
        `productid=${bus.productInfo.productid}`,
      ];
      params = params.join('&');
      util.ajax.get(`/app/rest/exception.json/getErrorTypeSummary?${params}`, {
        cancelToken: self.source.token,
      }).then((res) => {
        if (res.length) {
          const result = res;
          const tab = self.tabDatas;
          Object.keys(tab).forEach((m) => {
            Object.keys(result).forEach((n) => {
              if (tab[m].exception_type1 === result[n].exception_type1) {
                tab[m].type = `${result[n].exception_errortype} | ${result[n].exception_errorsummary}`;
              }
            });
          });
          self.getSearchData();
        }
      }).catch((thrown) => {
        if (axios.isCancel(thrown)) {
          // 请求取消
        }
      });
    },
    // 获取各个时段发生次数数据
    getData(data) {
      const exList = [];
      for (let i = 0; i < data.length; i++) {
        exList.push(data[i].exception_type1);
      }
      this.exceList = exList;
      this.recursionGetData(0);
    },
    // 递归获取数据
    recursionGetData(index) {
      const len = this.exceList.length;
      const size = Math.ceil(len / 50);
      if (index < size) {
        // 表格后三列数据，递归50条请求一次
        const end = index === size - 1 ? len : (index + 1) * 50;
        const exList = this.exceList.slice(index * 50, end);

        // 获取今日发生次数
        this.fetchData(bus.selectedDate[1], bus.selectedDate[1], exList).then((res) => {
          Object.keys(res).forEach((i) => {
            Object.keys(this.tabDatas).forEach((j) => {
              if (res[i].exception_type1 === this.tabDatas[j].exception_type1) {
                this.tabDatas[j].today = res[i].exception;
              }
            });
          });
          this.recursionGetData(index + 1);
        }).catch((thrown) => {
          if (axios.isCancel(thrown)) {
            // 请求取消
          }
        });

        // 获取七日发生次数
        this.fetchData(bus.getDay(-7), bus.selectedDate[1], exList).then((res) => {
          Object.keys(res).forEach((i) => {
            Object.keys(this.tabDatas).forEach((j) => {
              if (res[i].exception_type1 === this.tabDatas[j].exception_type1) {
                this.tabDatas[j].week = res[i].exception;
//                break;
              }
            });
          });
        }).catch((thrown) => {
          if (axios.isCancel(thrown)) {
            // 请求取消
          }
        });

        // 获取时段内次数
        this.fetchData(bus.selectedDate[0], bus.selectedDate[1], exList).then((res) => {
          Object.keys(res).forEach((i) => {
            Object.keys(this.tabDatas).forEach((j) => {
              if (res[i].exception_type1 === this.tabDatas[j].exception_type1) {
                this.tabDatas[j].interval = res[i].exception;
//                break;
              }
            });
          });
        }).catch((thrown) => {
          if (axios.isCancel(thrown)) {
            // 请求取消
          }
        });
      }
    },
    // 请求数据
    fetchData(startTime, endTime, exlist) {
      const param = {
        metrics: ['exception'],
        groupby: 'exception_type1',
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          exceptionType1_list: exlist,
          platformid: bus.isAllPlatform ? '' : bus.platform.toString(),
          start: startTime,
          end: endTime,
          partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          usergroup_list: bus.conditions.usergroup.length === 0 ? undefined
          : bus.conditions.usergroup,
          version_list: this.relationCodeList.length ? this.relationCodeList : undefined,
        },
      };
      return util.ajax.post('/app/rest/data.json/query', param, {
        cancelToken: this.source.token,
      });
    },
    /**
     * 获取检索后数据
     * @param index, index为Object表示搜索框触发的此函数，index为Number表示改变页码触发的此函数，
     index为空，表示ajax数据获取后触发的此函数
     **/
    getSearchData(index) {
      const data = this.tabDatas;
      const key = this.key.toLowerCase();
      if (this.key === '') {
        this.getTableData(data);
        return;
      }
      this.curPage = typeof (index) === 'object' || !index ? 1 : index;
      const result = [];
//      for (const i of Object.keys(data)) {
//        if (data[i].type.toLowerCase().indexOf(key) !== -1) {
//          result.push(data[i]);
//        }
//      }
      Object.keys(data).forEach((i) => {
        if (data[i].type.toLowerCase().indexOf(key) !== -1) {
          result.push(data[i]);
        }
      });
      this.pages = result.length;
      this.getTableData(result);
    },
    /**
     * 获取表格数据
     * @param filterRes {Array} 过滤后的所有数据
     * @param ind {Number} 排序操作--sortData后传递的值 为1,其余操作不传
     **/
    getTableData(filterRes, ind) {
      const cur = !ind ? this.curPage : ind;
      // 排序操作后当前页置为1
      this.curPage = !ind ? this.curPage : ind;
      const size = this.pageSize;
      this.pages = filterRes.length;

      const start = (cur - 1) * size;
      let offset = size;
      if (cur * size >= filterRes.length) {
        offset = filterRes.length - start;
      }
      const result = [];
      for (let i = start; offset > 0; i++) {
        result.push(filterRes[i]);
        offset--;
      }
      this.tableData = result;
      if (result.length === 0) {
        this.noData = this.$t('common.nodata');
      }
    },
    changePage(index) {
      this.curPage = index;
      this.getSearchData(index);
    },
    checkDetail(data) {
      busModual.currentErrType = data;
//    bus.$emit('current-err');
      this.$router.push({
        name: 'errorDetail',
      });
    },
    // 导出数据
    downTable() {
      const filename = bus.getDownloadName(this.$t('errlist.title'));
      this.$refs.table.exportCsv({
        filename,
      });
    },
  },
};
</script>
